import React, { useState, FormEvent } from "react";
import { useHistory } from "react-router-dom";
import Lottie from "react-lottie";

import api from "../../services/api";

import PageHeader from "../../components/PageHeader";
import Input from "../../components/Input";
import Textarea from "../../components/Textarea";
import Select from "../../components/Select";

import warningIcon from "../../assets/images/icons/warning.svg";
import okAnimation from "../../assets/animation/ok.json";
import errorAnimation from "../../assets/animation/error.json";

import "./styles.css";

const TeacherForm = () => {
  const history = useHistory();

  const [name, setName] = useState("");
  const [avatar, setAvatar] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [bio, setBio] = useState("");

  const [subject, setSubject] = useState("");
  const [cost, setCost] = useState("");

  const [scheduleItems, setScheduleItems] = useState([
    { week_day: 0, from: "", to: "" },
  ]);

  const [animation, setAnimation] = useState({
    isVisible: false,
    isStopped: false,
    isPaused: false,
    animationOk: true,
    animationError: false,
    animationLabel: "",
  });

  const defaultOptionsAnimation = {
    loop: false,
    autoplay: true,
    animationData: animation.animationOk ? okAnimation : errorAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  function addNewScheduleItem() {
    setScheduleItems([...scheduleItems, { week_day: 0, from: "", to: "" }]);
  }

  function setScheduleItemValue(
    position: number,
    field: string,
    value: string
  ) {
    const updatedScheduleItems = scheduleItems.map((scheduleItem, index) => {
      if (index === position) {
        return { ...scheduleItem, [field]: value };
      }

      return scheduleItem;
    });

    setScheduleItems(updatedScheduleItems);
  }

  async function startAnimation(
    animationOk: boolean,
    animationError: boolean,
    animationLabel: string
  ) {
    setAnimation({
      ...animation,
      isVisible: true,
      animationOk,
      animationError,
      animationLabel,
    });

    await new Promise((resolve) => setTimeout(resolve, 2500));

    setAnimation({
      ...animation,
      isVisible: false,
    });
  }

  async function handleCreateClass(e: FormEvent) {
    e.preventDefault();

    try {
      await api.post("classes", {
        name,
        avatar,
        whatsapp,
        bio,
        subject,
        cost: Number(cost),
        schedule: scheduleItems,
      });

      const animationOk = true;
      const animationError = false;
      const animationLabel = "Cadastro realizado com sucesso";

      await startAnimation(animationOk, animationError, animationLabel);

      history.push("/");
    } catch (error) {
      const animationOk = false;
      const animationError = true;
      const animationLabel = "Erro no cadastro.";

      await startAnimation(animationOk, animationError, animationLabel);
    }
  }

  return (
    <div id="page-teacher-form" className="container">
      <PageHeader
        title="Que incrível que você quer dar aulas!"
        description="O primeiro passo é preencher esse formulário de inscrição"
      />

      <main>
        <form onSubmit={handleCreateClass}>
          <fieldset>
            <legend>Seus dados</legend>
            <Input
              name="name"
              label="Nome completo"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
            <Input
              name="avatar"
              label="Avatar (imagem)"
              placeholder="https://"
              value={avatar}
              onChange={(e) => {
                setAvatar(e.target.value);
              }}
            />
            <Input
              name="whatsapp"
              label="WhatsApp"
              value={whatsapp}
              onChange={(e) => {
                setWhatsapp(e.target.value);
              }}
            />
            <Textarea
              name="bio"
              label="biografia"
              value={bio}
              onChange={(e) => {
                setBio(e.target.value);
              }}
            />
          </fieldset>

          <fieldset>
            <legend>Sobre a aula</legend>

            <Select
              name="subject"
              label="Matéria"
              value={subject}
              onChange={(e) => {
                setSubject(e.target.value);
              }}
              options={[
                { value: "Artes", label: "Artes" },
                { value: "Matemática", label: "Matemática" },
                { value: "Biologia", label: "Biologia" },
                { value: "Física", label: "Física" },
                { value: "Química", label: "Química" },
                { value: "História", label: "História" },
                { value: "Português", label: "Português" },
                { value: "Educação Física", label: "Educação Física" },
              ]}
            />

            <Input
              name="cost"
              label="Custo da sua hora por aula (R$)"
              value={cost}
              onChange={(e) => {
                setCost(e.target.value);
              }}
            />
          </fieldset>

          <fieldset>
            <legend>
              Horários disponíveis
              <button type="button" onClick={addNewScheduleItem}>
                + Novo horário
              </button>
            </legend>

            {scheduleItems.map((scheduleItem, index) => {
              return (
                <div key={scheduleItem.week_day} className="schedule-item">
                  <Select
                    name="week_day"
                    label="Dia da semana"
                    value={scheduleItem.week_day}
                    onChange={(e) =>
                      setScheduleItemValue(index, "week_day", e.target.value)
                    }
                    options={[
                      { value: "0", label: "Domingo" },
                      { value: "1", label: "Segunda-feira" },
                      { value: "2", label: "Terça-feira" },
                      { value: "3", label: "Quarta-feira" },
                      { value: "4", label: "Quinta-feira" },
                      { value: "5", label: "Sexta-feira" },
                      { value: "6", label: "Sábado" },
                    ]}
                  />

                  <Input
                    name="from"
                    label="Das"
                    type="time"
                    value={scheduleItem.from}
                    onChange={(e) =>
                      setScheduleItemValue(index, "from", e.target.value)
                    }
                  />

                  <Input
                    name="to"
                    label="Até"
                    type="time"
                    value={scheduleItem.to}
                    onChange={(e) =>
                      setScheduleItemValue(index, "to", e.target.value)
                    }
                  />
                </div>
              );
            })}
          </fieldset>

          <footer>
            <p>
              <img src={warningIcon} alt="Aviso importante" />
              Importante! <br />
              Preencha todos os dados
            </p>
            <button type="submit">Salvar cadastro</button>
          </footer>
        </form>
      </main>

      {animation.isVisible ? (
        <div className="modal">
          <div className="animation">
            <Lottie
              options={defaultOptionsAnimation}
              height={400}
              width={400}
              isStopped={animation.isStopped}
              isPaused={animation.isPaused}
            />
            <h1>{animation.animationLabel}</h1>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default TeacherForm;
